var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "input-wrapper" }, [
    _vm.label
      ? _c(
          "label",
          {
            class: { active: _vm.value && _vm.value.length > 0 },
            attrs: { for: _vm.id }
          },
          [_vm._v(_vm._s(_vm.label))]
        )
      : _vm._e(),
    _c("textarea", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.value,
          expression: "value"
        }
      ],
      ref: "textareaValue",
      class: _vm.classList,
      attrs: {
        name: _vm.name,
        id: _vm.id,
        placeholder: _vm.placeholder,
        maxlength: _vm.maxLength,
        rows: _vm.rows,
        resize: "vertical"
      },
      domProps: { value: _vm.value },
      on: {
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.value = $event.target.value
        }
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-635912e1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-635912e1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/shared/_any/InputTextarea.vue
// module id = HMR7
// module chunks = 41